import React from 'react';
import { useSnackbar } from 'notistack';
import { useAppDispatch } from 'store/hooks';
import { perkTemplateApi } from 'components/perks/templates/PerkTemplateApi';
import { PerkTemplate } from 'components/perks/templates/models/PerkTemplate';
import { deleteSuccess } from 'store/perk-templates/perkTemplatesSlice';
import {
    MESSAGE_MARKETING_PERK_TEMPLATE_DELETE_ERROR,
    MESSAGE_MARKETING_PERK_TEMPLATE_DELETE_SUCCESS
} from 'config/messages';

export const usePerkTemplatesMutation = (
    templateToDelete: PerkTemplate | null,
    onDeleteSuccess: () => void
) => {
    const dispatch = useAppDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const [deleteLoading, setDeleteLoading] = React.useState(false);

    const handleDeleteConfirm = React.useCallback(async () => {
        if (!templateToDelete) {
            return;
        }
        setDeleteLoading(true);
        try {
            const response = await perkTemplateApi.delete(templateToDelete._id);
            if (!response.ok) {
                throw new Error(response.body?.message || 'Failed to delete template');
            }
            enqueueSnackbar(MESSAGE_MARKETING_PERK_TEMPLATE_DELETE_SUCCESS, { variant: 'success' });
            dispatch(deleteSuccess(templateToDelete._id));
            onDeleteSuccess();
        } catch {
            enqueueSnackbar(MESSAGE_MARKETING_PERK_TEMPLATE_DELETE_ERROR, { variant: 'error' });
        } finally {
            setDeleteLoading(false);
        }
    }, [templateToDelete, dispatch, enqueueSnackbar, onDeleteSuccess]);

    return {
        deleteLoading,
        handleDeleteConfirm
    };
};
